
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class ChatTextarea extends Vue {
  @Prop({ default: '' }) placeholer!: string;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: 6 }) rows!: number;
  @Prop({ default: false }) noPadding!: boolean;

  numberOfLines = 1

  get height () {
    return 35 + (23 * (this.numberOfLines - 1)) + 'px'
  }

  mounted () {
    this.textAreaAdjust(this.$refs.chatTextarea as HTMLTextAreaElement)
  }

  @Watch('value')
  onValueChange () {
    setTimeout(() => this.textAreaAdjust(this.$refs.chatTextarea as HTMLTextAreaElement), 10)
  }

  textAreaAdjust (element: HTMLTextAreaElement) {
    element.style.height = '1px'
    element.style.height = (3 + element.scrollHeight) + 'px'
  }

  get placeholderInPlace () {
    return this.placeholer ?? ''
  }
}
